<template>
    <div class="d-flex fill-height of-y">
        <div v-if="startingUp" class="fill-height flex-grow-1 d-flex align-center justify-center">
            <app-centre-loader label="Loading Invoices"></app-centre-loader>
        </div>
        <v-scroll-x-transition hide-on-leave>
            <div class="fill-height of-y flex-grow-1" v-if="!startingUp">
                <v-data-table
                        ref="table"
                        :headers="headers"
                        :items="invoices || []"
                        :search="$store.state.ref.dashboard.filterStr"
                        :items-per-page="snapshots && snapshots.length || 0"
                        class="fill-height of-y full-table"
                        hide-default-footer
                        fixed-header
                        item-key="_id"
                >

                    <template v-slot:item.runTime="{ item }">
                        {{item.dateStr}}
                    </template>

                    <template v-slot:item.plan="{ item }">
                        <div class="overline d-flex align-center" style="line-height: 1">
                            {{item.plan}}
                        </div>
                    </template>

                    <template v-slot:item.status="{ item }">
                        <div class="overline d-flex align-center" style="line-height: 1">
                            {{item.status}}
                        </div>
                    </template>

<!--                                                label-->
<!--                    <template v-slot:item.label="{ item }">-->
<!--                        <div class="d-flex align-center overline" :class="`${labelsRef[item.label].color}&#45;&#45;text`">-->
<!--                            <v-icon small :color="labelsRef[item.label].color" left>{{labelsRef[item.label].icon}}</v-icon>-->
<!--                            {{labelsRef[item.label].text}}-->
<!--                        </div>-->
<!--                    </template>-->

<!--                    <template v-slot:item.tt="{ item }">{{ hoursDisplay(item.tt, true) }}</template>-->
<!--                    <template v-slot:item.ttn="{ item }">{{ hoursDisplay(item.ttn, true) }}</template>-->
<!--                    <template v-slot:item.tto="{ item }">{{ hoursDisplay(item.tto, true) }}</template>-->

<!--                                                count-->

                    <template v-slot:item.detail="{ item }">
                        <v-btn
                                color="primary"
                                class="mx-2"
                                small
                                outlined
                                @click.stop="$refs.snapshotExplorer.previewSnapshot(item)"
                        >
                            View Detail
                        </v-btn>
                    </template>

<!--                    <template v-slot:item.download="{ item }">-->
<!--                        <v-tooltip left>-->
<!--                            <template v-slot:activator="{on}">-->
<!--                                <v-btn-->
<!--                                        color="primary"-->
<!--                                        class="mx-2"-->
<!--                                        small-->
<!--                                        icon-->
<!--                                        v-on="on"-->
<!--                                        :disabled="item.status !== 'ACTIVE'"-->
<!--                                >-->
<!--                                    <v-icon>mdi-cloud-download</v-icon>-->
<!--                                </v-btn>-->
<!--                            </template>-->
<!--                            {{item.status === "ACTIVE" ? "Download Invoice" : "Not Available"}}-->
<!--                        </v-tooltip>-->
<!--                    </template>-->

                </v-data-table>
            </div>
        </v-scroll-x-transition>

        <app-employee-snapshot-explorer ref="snapshotExplorer"></app-employee-snapshot-explorer>
    </div>
</template>

<script>
import AppCentreLoader from "@/components/Shared/AppCentreLoader";
import {format} from "date-fns";
import {dateFormats} from "@/core/codeFunctions";
import AppEmployeeSnapshotExplorer from "@/components/Shared/EmployeeSnapshotExplorer/AppEmployeeSnapshotExplorer";

export default {
    components: {AppCentreLoader, AppEmployeeSnapshotExplorer},
    data() {
        return {
            startingUp: false,
            snapshots: null,
            headers: [
                {text: 'Date', value: 'runTime', sort: "DESC"},
                {text: 'Status', value: 'status', sort: "DESC"},
                {text: 'Plan', value: 'plan', sort: "DESC"},
                {text: 'Employees', value: 'employeesCount'},
                {text: 'Devices', value: 'devicesCount'},
                {text: 'Days Tracked', value: 'daysCount'},
                {
                    text: '',
                    value: 'detail',
                    sortable: false,
                    align: 'center',
                    width: 30
                },
                {
                    text: '',
                    value: 'download',
                    sortable: false,
                    align: 'center',
                    width: 30
                }
            ],
            format,
            dateFormats,
        }
    },
    mounted() {
        this.startup()
    },
    methods: {
        async startup() {
            try {
                this.startingUp = true;
                const snapshots = await this.$newReq("GET", `setup/invoices/startup`)
                this.snapshots = snapshots.map(shot => {
                    shot.createdAt = new Date(shot.createdAt)
                    shot.runTime = new Date(shot.runTime)
                    return shot
                })
                console.log(this.snapshots)
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError();
            } finally {
                this.startingUp = false;
            }
        }
    },
    computed: {
        filterStr() {
            return this.$store.state.ref.admin.invoices.filterStr
        },
        invoices() {
            return (this.snapshots && this.snapshots.length ? this.snapshots.map(snap => {

                const {devices: devicesCount, days: daysCount} = snap.snapshot.reduce((summary, employee) => {
                    summary.devices = summary.devices + employee.devices.length
                    summary.days = summary.days + employee.daysUsed
                    return summary
                }, {devices: 0, days: 0});

                return {
                    ...snap,
                    employeesCount: snap.snapshot.length,
                    dateStr: format(snap.runTime, dateFormats.longDateOnly),
                    devicesCount,
                    daysCount,
                }
            }) : [])
                    .filter(shot => this.filterStr ? JSON.stringify(shot).toLowerCase().includes((this.filterStr || '').toLowerCase()) : true)
        },
    },
}
</script>

<style scoped>

</style>